export const Resources = {
  CredentialsKey: 'Accesses',
};

export enum ResponseMessagesTypes {
  InvalidUsernamePassword = 'Login_Error_InvalidUsernamePassword',
}
